import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {SigedCommonService} from '../../siged-common.service';
import {AuthService} from '../../services/auth.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  private bandejas = new BehaviorSubject(undefined)
  private baseUrl = this.mpvCommonService.APPLICATION_API_HOST;
  private defaultHeaders;

  constructor(
      private http: HttpClient,
      private authService: AuthService,
      public mpvCommonService: SigedCommonService) {
      this.defaultHeaders = {
          Authorization: 'Bearer ' + this.authService.getUser()
      }
  }

  getBandejas() {
    return this.bandejas.asObservable()
  }

  setBandejas(data) {
    this.bandejas.next(data)
  }

  setDefaultBandeja(
      body: {
          idPadre: number,
          idPersona: number,
      },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
      const options = { headers: { ... this.defaultHeaders, ...headers } }
      return this.http.post(`${this.baseUrl}/persona/seleccionarBandeja`, body, options).toPromise();
  }
}
